<template>
    <div id="app">
        <SiteHeader class="layout--site-header" />

        <transition name="slide-down">
            <CustomerName
                v-if="showCustomerName"
                :key="`customer-name-${customerId}`"
            />
        </transition>

        <router-view
            class="layout--router-view"
            :is-window-small="isWindowSmall"
        />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { addUserToSentry } from '@/plugins/sentry';

import CustomerName from '@/components/showroom/customer-name';
import SiteHeader from '@/components/header/site-header';

export default {
    name: 'App',

    components: {
        CustomerName,
        SiteHeader,
    },

    data() {
        return {
            windowWidth: window.innerWidth,
        };
    },

    computed: {
        ...mapGetters({
            customerId: 'user/customerId',
            isEmployee: 'user/isEmployee',
            userEmail: 'user/userEmail',
            userId: 'user/userId',
            userName: 'user/userName',
        }),
        isAuthenticated() {
            return this.$auth0.isAuthenticated;
        },
        isWindowSmall() {
            return this.windowWidth < 1000;
        },
        showCustomerName() {
            return this.isEmployee && !!this.customerId;
        },
    },

    watch: {
        async isAuthenticated() {
            if (this.isAuthenticated) {
                // Set details from auth0
                this.setUserDetails({ ...this.$auth0.user });

                // Fetch personal details for customers
                if (!this.isEmployee) {
                    await this.fetchPersonalDetails(this.customerId);
                }

                if (process.env.NODE_ENV === 'production') {
                    addUserToSentry({
                        id: this.userId,
                        email: this.userEmail,
                        name: this.userName,
                    });
                }
            }
        },
    },

    created() {
        window.addEventListener('resize', this.updateWidth);
    },

    destroyed() {
        window.removeEventListener('resize', this.updateWidth);
    },

    methods: {
        ...mapActions({
            fetchPersonalDetails: 'user/FETCH_CUSTOMER_PERSONAL_DETAILS',
            setUserDetails: 'user/SET_USER_DETAILS',
        }),
        updateWidth() {
            this.windowWidth = window.innerWidth;
        },
    },
};
</script>

<style lang="scss">
@import './assets/scss/partials/base';
@import './assets/scss/partials/animations';

#app {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.layout--site-header {
    flex: none;
}
.layout--router-view {
    flex: auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

@media print {
    #app {
        height: auto !important;
    }
    .layout--site-header {
        display: none !important;
    }
    .layout--router-view {
        overflow: visible !important;
    }
}
</style>
